import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 852E3EF2-942E-42C5-87BB-E1193EBD3E0C
 * name chart-scatter-plot-hexbin
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-scatter-plot-hexbin.svg
 * tags
 * - Math 
 */
export const ChartScatterPlotHexbinIcon = createSvgIcon(<><path d="M2,2H4V20H22V22H2V2M14,14.5L12,18H7.94L5.92,14.5L7.94,11H12L14,14.5M14.08,6.5L12.06,10H8L6,6.5L8,3H12.06L14.08,6.5M21.25,10.5L19.23,14H15.19L13.17,10.5L15.19,7H19.23L21.25,10.5Z" /></>, 'ChartScatterPlotHexbinIcon');
export default ChartScatterPlotHexbinIcon